// Recovered compiled webpack factory 6640. Edit this function expression; run npm run build.
(e, t, r) => {
  "use strict";
  function n() {
    throw Object.defineProperty(
      Error(
        "`unauthorized()` is experimental and only allowed to be used when `experimental.authInterrupts` is enabled.",
      ),
      "__NEXT_ERROR_CODE",
      { value: "E411", enumerable: !1, configurable: !0 },
    );
  }
  (Object.defineProperty(t, "__esModule", { value: !0 }),
    Object.defineProperty(t, "unauthorized", {
      enumerable: !0,
      get: function () {
        return n;
      },
    }),
    r(37099).HTTP_ERROR_FALLBACK_ERROR_CODE,
    ("function" == typeof t.default || ("object" == typeof t.default && null !== t.default)) &&
      void 0 === t.default.__esModule &&
      (Object.defineProperty(t.default, "__esModule", { value: !0 }),
      Object.assign(t.default, t),
      (e.exports = t.default)));
}
